import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../../../assets/utils/accessToken";

export const fetchReportDocuments = createAsyncThunk(
    "ReportDocument/fetchReportDocuments",
    async (_, { getState, requestId, rejectWithValue }) => {
        const { currentRequestId, loading } = getState().ReportDocument
        if (loading !== 'pending' || requestId !== currentRequestId) {
            return
        }
        const token = localStorage.getItem("token");
        // try {
        const response = await axios.get(
            BaseUrl + `/htmlTemplateReports/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        return response.data;
        // } catch (err) {
        //     console.log("err",err)
        //     let error = err; // cast the error for access
        //     console.log("error",error)

        //     if (!error.response) {
        //         throw err;
        //     }
        //     return rejectWithValue(error?.response?.data);
        // }
    }
);

export const fetchReportDocument = createAsyncThunk(
    "ReportDocument/fetchReportDocument",
    async (id, { getState, requestId, rejectWithValue }) => {
        const { currentRequestId, loading } = getState().ReportDocument
        if (loading !== 'pending' || requestId !== currentRequestId) {
            return
        }
        const token = localStorage.getItem("token");
        // try {
        const response = await axios.get(
            BaseUrl + `/htmlTemplateReports/${id}`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        return response.data;
        // } catch (err) {
        //     let error = err; // cast the error for access
        //     if (!error.response) {
        //         throw err;
        //     }
        //     return rejectWithValue(error?.response?.data);
        // }
    }
);

export const createReportDocument = createAsyncThunk(
    "ReportDocument/createReportDocument",
    async (data, { rejectWithValue }) => {
        const token = localStorage.getItem("token");

        try {
            const response = await axios.post(
                BaseUrl + `/htmlTemplateReports/create/`,
                data,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );
            return response.data;
        } catch (err) {
            let error = err // cast the error for access
            if (!error.response) {
                throw err
            }
            // We got validation errors, let's return those so we can reference in our component and set form errors
            return rejectWithValue(error.response.data)
        }
    }
);

export const updateReportDocument = createAsyncThunk(
    "ReportDocument/updateReportDocument",
    async (data, { rejectWithValue }) => {
        const token = localStorage.getItem("token");

        try {
            const { id, ...fields } = data

            const response = await axios.put(
                BaseUrl + `/htmlTemplateReports/${id}/edit/`,
                fields,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );
            return response.data;
        } catch (err) {
            let error = err // cast the error for access
            if (!error.response) {
                throw err
            }
            // We got validation errors, let's return those so we can reference in our component and set form errors
            return rejectWithValue(error.response.data)
        }
    }
);

export const deleteReportDocument = createAsyncThunk(
    "ReportDocument/deleteReportDocument",
    async (id, { rejectWithValue }) => {
        const token = localStorage.getItem("token");

        const response = await axios.delete(
            BaseUrl + `/htmlTemplateReports/${id}/delete/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        return response.data;

    }
);
const ReportDocumentsSlice = createSlice({
    name: "ReportDocument",
    initialState: {
        reportDocuments: [],
        reportDocument: null,
        loading: "idle",
        currentRequestId: undefined,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReportDocuments.pending, (state, action) => {
                if (state.loading === 'idle') {
                    state.loading = 'pending'
                    state.currentRequestId = action.meta.requestId
                }
            })
            .addCase(fetchReportDocuments.fulfilled, (state, action) => {
                const { requestId } = action.meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'idle'
                    state.reportDocuments = action.payload
                    state.currentRequestId = undefined
                }
            })
            .addCase(fetchReportDocuments.rejected, (state, action) => {
                const { requestId } = action.meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'idle'
                    state.error = action.error
                    state.currentRequestId = undefined
                }
            })
        builder
            .addCase(fetchReportDocument.pending, (state, action) => {
                if (state.loading === 'idle') {
                    state.loading = 'pending'
                    state.currentRequestId = action.meta.requestId
                }
            })
            .addCase(fetchReportDocument.fulfilled, (state, action) => {
                const { requestId } = action.meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'idle'
                    state.reportDocument = action.payload
                    state.currentRequestId = undefined
                }
            })
            .addCase(fetchReportDocument.rejected, (state, action) => {
                const { requestId } = action.meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'idle'
                    state.error = action.error
                    state.currentRequestId = undefined
                }
            })
        builder.addCase(createReportDocument.rejected, (state, action) => {
            if (action.payload) {
                // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                state.error = action.payload.errorMessage
            } else {
                state.error = action.error.message
            }
        })
        builder.addCase(updateReportDocument.rejected, (state, action) => {
            if (action.payload) {
                // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                state.error = action.payload.errorMessage
            } else {
                state.error = action.error.message
            }
        })
        builder.addCase(deleteReportDocument.rejected, (state, action) => {
            if (action.payload) {
                // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                state.error = action.payload.errorMessage
            } else {
                state.error = action.error.message
            }
        })
    },
});

export default ReportDocumentsSlice.reducer;
